export default __webpack_public_path__ + "static/media/devX_home.33b4562e.svg";